require('./mortgageRequestPreApprovalStepThree.scss');
require('./mortgageRequestPreApprovalStepThree.override.scss');

//@Vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
//@commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
//@components
const MortgageRequestCardInformation = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestCardInformation/mortgageRequestCardInformation');
const MortgageRequestDateOfBirthForm = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestDateOfBirthForm/mortgageRequestDateOfBirthForm');
const MortgageRequestHomeOwnershipForm = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestHomeOwnershipForm/mortgageRequestHomeOwnershipForm');
const MortgageRequestWorkForm = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestWorkForm/mortgageRequestWorkForm');
const MortgageRequestOtherLoans = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestOtherLoans/mortgageRequestOtherLoans');
const MortgageRequestMaritalStatusAndDependents = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestMaritalStatusAndDependents/mortgageRequestMaritalStatusAndDependents');
const MortagageRequestMonthlyIncomeAndExpenses = require('components/mortgageRequest/mortgageRequestPreApproval/mortagageRequestMonthlyIncomeAndExpenses/mortagageRequestMonthlyIncomeAndExpenses');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@utilities
const DateHelper = require('utilities/dateHelper');
const mortgageRequestPreApprovalHelper = require('../mortgageRequestPreApprovalHelper');
const {
    formatAmount,
} = require('utilities/currencyHelper');
const { mortgagesPreApprovalIntrestPeriodSubtitle } = require('utilities/mortgageHelper');
// @constants
const { maritalStatusOptions,
    laborSituationOptions,
    studiesLevelOptions,
    mortgageRequestPreApprovalCommons,
    mortgagesRequestOtherLoansCommons,
    idModalsMortgageRequest
} = require('constants/mortgageRequestPreApproval');
const {
    HOLDER_OPTION_ONE,
    HOLDER_OPTION_TWO,
    HOLDER_OPTION_ONE_LABEL,
    HOLDER_OPTION_TWO_LABEL,
    ONE_DEPENDENT,
    EMPTY_STRING,
    LEGAL_AGE,
    MORTGAGE_COLLECTIVE_PRODUCT_ALIAS,
    MAX_DEPENDENTS
} = mortgageRequestPreApprovalCommons;
const {
    MONTHLY_FEES_LOANS,
    PENDING_AMOUNT_LOANS,
    PERSONAL_LOANS,
    OTHER_MORTGAGE,
    GOING_CANCEL_MORTGAGE,
    MONTHLY_FEES_MORTGAGE,
    PENDING_AMOUNT_MORTGAGE
} = mortgagesRequestOtherLoansCommons;
const { THIRD_STEP, EURO_TEXT, PERCENTAGE_SYMBOL, YES, NO } = require('constants/index');
const { DATE_OF_BIRTH, HOME_OWNER_SHIP, WORK, MARITAL, OTHER_LOANS_AND_MORTGAGES, INCOMES_AND_EXPENSES } = idModalsMortgageRequest;

const { getMortgageTypeText } = require('constants/mortgageRequestType');
//@commons
const { mortgageProductCatalogIdentifiers, afiMortgageProductTypes } = require('constants/mortgageRequestPreApproval');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');

class MortgageRequestPreApprovalStepThree extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            temporalHolderBirthDates: {
                holderOne: {},
                holderTwo: {}
            }
        };

        this.clearTemporalInformation = this.clearTemporalInformation.bind(this);
        this.setTemporalHolderBirthDates = this.setTemporalHolderBirthDates.bind(this);
    }

    componentDidMount() {
        const { immMortgageRequest, formHandlers, immProfile, requestConditions } = this.props;
        const { handleHolderDayOfBirthChange,
            handleHolderMonthOfBirthChange,
            handleHolderYearOfBirthChange,
            handleLoadValidateObligatoryFields } = formHandlers;

        const dateOfBirthProfile = immProfile.get('fechaNacimiento').split('-').reverse();
        const holderOneInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);

        let holderOneDayOfBirth = holderOneInfo.get('dayOfBirth');
        let holderMonthOfBirth = holderOneInfo.get('monthOfBirth');
        let holderYearOfBirth = holderOneInfo.get('yearOfBirth');

        if (holderOneDayOfBirth === EMPTY_STRING && holderMonthOfBirth === EMPTY_STRING && holderYearOfBirth === EMPTY_STRING) {

            [holderOneDayOfBirth, holderMonthOfBirth, holderYearOfBirth] = dateOfBirthProfile;
            handleHolderDayOfBirthChange(holderOneDayOfBirth, HOLDER_OPTION_ONE);
            handleHolderMonthOfBirthChange(holderMonthOfBirth, HOLDER_OPTION_ONE);
            handleHolderYearOfBirthChange(holderYearOfBirth, HOLDER_OPTION_ONE);
        }

        if(requestConditions) requestConditions();
        handleLoadValidateObligatoryFields();
    }

    buildCollectiveMessages(mortgageType, defaultMortgageData, collectiveMortgageData) {
        const className = "mortgage-request-preapproval-step-three__header-quota__tae";
        if (afiMortgageProductTypes.FIJO === mortgageType) {
            const stringValue = ['mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_quotaCollectiveFixed'];
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);

        } else if (afiMortgageProductTypes.VARIABLE === mortgageType) {
            const stringValue = ['mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_quotaCollectiveVariable'];
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);
        } else {
            const stringValue = ['mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_quotaCollectiveMixedTIN',
                'mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_quotaCollectiveMixedTAE'];
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);
        }
    }

    buildHeader() {
        const { immMortgageRequest, immCollectives, mortgageConditions } = this.props;
        const mortgageType = getMortgageTypeText(immMortgageRequest.get('productType').toUpperCase());
        const originalTerm = immMortgageRequest.get('timeMoneyReturn');
        const amount = immMortgageRequest.get('moneyNeed');
        const formattedAmount = MortgageRequestCurrencyHelp({ currency: amount, symbol: EURO_TEXT, withDecimals: false });
        let preapprovalQuotaParams, formattedQuota;
        const preApprovalQuotaCost = immMortgageRequest.get('monthlyFeeAFI') || immMortgageRequest.get('monthlyFeeWF');
        if (preApprovalQuotaCost && !isNaN(preApprovalQuotaCost)) {
            preapprovalQuotaParams = {
                currency: preApprovalQuotaCost,
                symbol: EURO_TEXT,
                withDecimals: true
            };
            formattedQuota = MortgageRequestCurrencyHelp(preapprovalQuotaParams);
        } else {
            formattedQuota = 'TBD';
        }
        const productType = immMortgageRequest.get('productType');
        const isCollective = immCollectives.getIn(['collective', 'isCollective']);
        const mortgageTin = `${formatAmount(immMortgageRequest.get('tin'))}${PERCENTAGE_SYMBOL}`;
        const mortgageTae = `${formatAmount(immMortgageRequest.get('tae'))}${PERCENTAGE_SYMBOL}`;
        let productCatalog = immMortgageRequest.get('productCatalogAFI');
        let hasCollectiveBenefits = mortgageRequestPreApprovalHelper.hasCollectiveBenefits(productCatalog);
        let tooltipContent = '';

        if (!hasCollectiveBenefits) {
            productCatalog = immMortgageRequest.get('productCatalogWF');
            hasCollectiveBenefits = mortgageRequestPreApprovalHelper.hasCollectiveBenefits(productCatalog);
        }

        const conditions = mortgageConditions.get('conditions');
        const mortgagesIntrestText = mortgagesPreApprovalIntrestPeriodSubtitle(mortgageTin, mortgageTae, conditions);

        let feeAndTaxes = (<h2>
            <span className="mortgage-request-preapproval-step-three__header-quota__value">{formattedQuota}</span>
            <span className="mortgage-request-preapproval-step-three__header-quota__tae"> {mortgagesIntrestText}</span>
        </h2>);

        if (isCollective && hasCollectiveBenefits) {
            // Collective Tooltip Content start
            const taxes = {
                tin: !isNaN(hasCollectiveBenefits.tin) ? `${hasCollectiveBenefits.tin}%` : hasCollectiveBenefits.tin,
                tae: !isNaN(hasCollectiveBenefits.tae) ? `${hasCollectiveBenefits.tae}%` : hasCollectiveBenefits.tae,
                euribor: hasCollectiveBenefits.euribor
            };
            tooltipContent = (
                <MortgagesCollectiveTagTooltip
                    taxes={taxes}
                    mortgageType={productType}
                    monthlyFee={hasCollectiveBenefits.cuota}
                />
            );
            // Collective Tooltip Content finish

            const defaultValue = productCatalog.find(product => product.get('identificador') === mortgageProductCatalogIdentifiers.DEFAULT).toJS();
            const tinTaemessage = this.buildCollectiveMessages(mortgageType, defaultValue, hasCollectiveBenefits);
            let formattedCollectiveQuota = 'TBD';
            if (!isNaN(hasCollectiveBenefits.cuota)) {
                formattedCollectiveQuota = MortgageRequestCurrencyHelp({ currency: hasCollectiveBenefits.cuota, symbol: EURO_TEXT, withDecimals: true });
            }
            feeAndTaxes = (<h2>
                <span className="mortgage-request-preapproval-step-three__header-quota__value"><s><span>{formattedQuota}</span></s> {formattedCollectiveQuota}</span>
                {tinTaemessage}
            </h2>);
        }

        return (
            <header className="mortgage-request-preapproval-step-three__header">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="mortgage-request-preapproval-step-three__header-title">
                            <FormattedText
                                injectedStrings={[mortgageType]}
                                value="mortgageRequestPreApprovalStepThree-title"
                            />
                            <CollectiveTag
                                extraClass={"calculate-quota__collective-tag"}
                                productAlias={MORTGAGE_COLLECTIVE_PRODUCT_ALIAS}
                                tooltipContent={tooltipContent}
                            />
                        </h2>
                        <h3 className="mortgage-request-preapproval-step-three__header-subtitle">
                            <FormattedText
                                injectedStrings={[formattedAmount, originalTerm]}
                                value="mortgageRequestPreApprovalStepThree-subTitle"
                            />
                        </h3>
                        <div className="mortgage-request-preapproval-step-three__header-quota">
                            {feeAndTaxes}
                        </div>
                        <div className="mortgage-request-preapproval-step-three__header-explanatory-text">
                            <FormattedText value="mortgageRequestPreApprovalStepThree-explanatoryText" />
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    handleChangeSeletedHolder(holder, formHandlers) {
        formHandlers.handleHolderRadioChange(holder);
        formHandlers.handleLoadValidateObligatoryFields();
    }

    buildHolders() {
        const { immMortgageRequest, formHandlers } = this.props;
        const holderOptions = [
            {
                value: HOLDER_OPTION_ONE,
                label: HOLDER_OPTION_ONE_LABEL
            },
            {
                value: HOLDER_OPTION_TWO,
                label: HOLDER_OPTION_TWO_LABEL
            }
        ];
        const radioGroupOptions = holderOptions.map((holderOption, index) => (
            <RadioButton
                {...holderOption}
                key={'hipoOpenAditionalDataForm-' + index}
                className="block-step__radio"
            />
        ));

        return (
            <div className="col-md-12 mortgage-request-preapproval-step-three__holders">
                <span className="mortgage-request-preapproval-step-three__holders-title">
                    <FormattedText value="mortgageRequestPreApprovalStepThree-holdersTitle" />
                </span>
                <span className="mortgage-request-preapproval-step-three__holders-separator"></span>
                <RadioButtonGroup
                    name="holders"
                    idPrefix="holderRadio"
                    onChange={holder => this.handleChangeSeletedHolder(holder, formHandlers)}
                    className="mortgage-request-preapproval-step-three__holders-radio-group"
                    selectedValue={immMortgageRequest.get('selectedHolder')}
                >
                    {radioGroupOptions}
                </RadioButtonGroup>
            </div >
        );
    }

    formatDateOfBirth(day, month, year) {
        const monthFormatted = month ? DateHelper.getMonthFullName(parseInt(month)) : '';
        return `${day} ${monthFormatted} ${year}`
    }

    calculateSemicompleteModal(modal) {
        const { immMortgageRequest } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const firstHolderComplete = modal.getIn(['fields', HOLDER_OPTION_ONE, 'semiComplete'], false);
        let semiComplete = false;

        if (selectedHolder === HOLDER_OPTION_ONE) {
            semiComplete = firstHolderComplete;
        } else {
            semiComplete = firstHolderComplete || modal.getIn(['fields', HOLDER_OPTION_TWO, 'semiComplete'], false);
        }

        return semiComplete;
    }

    getDateValidity(day = '', month = '', year = '') {
        let valid = {
            validDate: false,
            legalAge: false,
            isEmpty: false
        };
        // the reason for this is to fix a bug related to the validity of the date in safari and IE11.
        day = day.length === 1 ? `0${day}` : `${day}`;
        month = month.length === 1 ? `0${month}` : `${month}`;
        year = `${year}`;

        if (year.length === 4 && month.length >= 1 && day.length >= 1) {
            const date = moment(`${year}-${month}-${day}`);
            const minAge = moment(date).add(LEGAL_AGE, 'years');
            const currentDate = moment();
            valid.legalAge = minAge < currentDate;
            valid.validDate = date.isValid() && date < currentDate;
        } else if (year.length === 0 && month.length === 0 && day.length === 0) {
            valid.emptyDate = true;
        }
        if (!year && !month && !day) {
            valid = Object.assign({}, valid, {
                isEmpty: true
            });
        }
        return valid;
    }

    setTemporalHolderBirthDates(holders) {
        this.setState({
            temporalHolderBirthDates: holders
        });
    }

    validBirthDayInformation(selectedHolder, holderOneInfo, holderTwoInfo) {

        let validBirthHolderOne = false;
        let validBirthHolderTwo = false;
        if(holderOneInfo) {
            validBirthHolderOne = this.getDateValidity(
                holderOneInfo.dayOfBirth,
                holderOneInfo.monthOfBirth,
                holderOneInfo.yearOfBirth
            );
        }
        const validHolderOne = validBirthHolderOne.isEmpty || validBirthHolderOne.validDate;

        if (holderTwoInfo && (selectedHolder === HOLDER_OPTION_TWO)) {
            validBirthHolderTwo = this.getDateValidity(
                holderTwoInfo.dayOfBirth,
                holderTwoInfo.monthOfBirth,
                holderTwoInfo.yearOfBirth
            );
            const validHolderTwo = validBirthHolderTwo.isEmpty || validBirthHolderTwo.validDate;
            return validHolderOne && validHolderTwo;
        }
        return validHolderOne
    }

    clearTemporalInformation() {
        const { discardTemporalChangesInCurrentModal } = this.props;
        this.setState({
            temporalHolderBirthDates: {
                holderOne: {},
                holderTwo: {}
            }
        });
        discardTemporalChangesInCurrentModal();
    }

    buildDateOfBirthCard() {
        const { temporalHolderBirthDates } = this.state;
        const {
            immMortgageRequest,
            formHandlers,
            isClientWithoutAccounts,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;

        const holderOneInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);
        const holderTwoInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO]);
        const dateOfBirthHolderOneFormatted = this.formatDateOfBirth(holderOneInfo.get('dayOfBirth'), holderOneInfo.get('monthOfBirth'), holderOneInfo.get('yearOfBirth'));
        const dateOfBirthHolderTwoFormatted = this.formatDateOfBirth(holderTwoInfo.get('dayOfBirth'), holderTwoInfo.get('monthOfBirth'), holderTwoInfo.get('yearOfBirth'));
        const validModal = immMortgageRequest.getIn(['validModals', DATE_OF_BIRTH], {});
        const valid = validModal.get('valid');
        const semiComplete = this.calculateSemicompleteModal(validModal);

        const isEmptyDateOfBirthFromState = dateOfBirthHolderOneFormatted.trim().replace(/ +/g, "") === EMPTY_STRING;
        const currentDateOfBirth = !isEmptyDateOfBirthFromState ? dateOfBirthHolderOneFormatted : EMPTY_STRING;

        const firstHolderInfo = [{ value: currentDateOfBirth, isEmptyDateOfBirth: isEmptyDateOfBirthFromState }];
        const secondHolderInfo = [{ value: dateOfBirthHolderTwoFormatted }];
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');

        const validBirthDayInformation = this.validBirthDayInformation(immMortgageRequest.get('selectedHolder'), temporalHolderBirthDates[HOLDER_OPTION_ONE], temporalHolderBirthDates[HOLDER_OPTION_TWO]);

        return (
            <MortgageRequestCardInformation
                title={formatText('mortgageRequestPreApprovalStepThree-birthDate')}
                firstHolderInfo={firstHolderInfo}
                secondHolderInfo={secondHolderInfo}
                immMortgageRequest={immMortgageRequest}
                isClientWithoutAccounts={isClientWithoutAccounts}
                valid={valid}
                semiComplete={semiComplete}
                errorText={errorText}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                idModal={DATE_OF_BIRTH}
                idNextModal={MARITAL}
                getDateValidity={this.getDateValidity}
                holders={[holderOneInfo, holderTwoInfo]}
                temporalHolderBirthDates={temporalHolderBirthDates}
                discardTemporalChangesInCurrentModal={this.clearTemporalInformation}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                isNavigationButtonsAvailable={validBirthDayInformation}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortgageRequestDateOfBirthForm
                    immMortgageRequest={immMortgageRequest}
                    isClientWithoutAccounts={isClientWithoutAccounts}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    getDateValidity={this.getDateValidity}
                    setTemporalHolderBirthDates={this.setTemporalHolderBirthDates}
                />
            </MortgageRequestCardInformation>
        );
    }

    searchAbbreviation(selected, items) {
        const options = items.options;
        const abbreviations = items.abbreviations;
        let item = null;
        let result = EMPTY_STRING;

        if (selected) {
            item = Object.keys(abbreviations).find(abbreviation => abbreviation === selected);

            if (item) {
                result = abbreviations[item];
            } else {
                item = Object.keys(options).find(constant => constant === selected);
                result = options[item];
            }

            result = formatText(result);
        }

        return result;
    }

    validMaritalInformation(selectedHolder, validModal, holderOneInfo, holderTwoInfo) {
        const validFirstHolderInfo =
            (validModal.getIn(['fields', HOLDER_OPTION_ONE, 'maritalStatus'], true) ||
                validModal.getIn(['fields', HOLDER_OPTION_ONE, 'valid'], true)) &&
            holderOneInfo.get('dependents') <= MAX_DEPENDENTS;

        if (selectedHolder === HOLDER_OPTION_TWO) {
            const validSecondHolderInfo =
                (validModal.getIn(['fields', HOLDER_OPTION_TWO, 'maritalStatus'], true) ||
                    validModal.getIn(['fields', HOLDER_OPTION_TWO, 'valid'], true)) &&
                holderTwoInfo.get('dependents') <= MAX_DEPENDENTS;

            return validFirstHolderInfo && validSecondHolderInfo;
        } else {
            return validFirstHolderInfo;
        }
    }

    buildMaritalStatusAndDependents() {
        const {
            immMortgageRequest,
            formHandlers,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;
        const holderOneInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);
        const holderTwoInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO]);
        const validModal = immMortgageRequest.getIn(['validModals', MARITAL], {});
        const valid = validModal.get('valid');
        const semiComplete = this.calculateSemicompleteModal(validModal);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');

        const validMaritalInformation = this.validMaritalInformation(immMortgageRequest.get('selectedHolder'),
            validModal, holderOneInfo, holderTwoInfo);

        const calculateDependentsValue = dependents => {
            const hasDependents = dependents !== '';
            let value = '';
            if (hasDependents && dependents === ONE_DEPENDENT) {
                value = `${dependents} ${formatText('mortgageRequestPreApprovalStepThree-person')}`;
            } else if (!!hasDependents && dependents !== ONE_DEPENDENT) {
                value = `${dependents} ${formatText('mortgageRequestPreApprovalStepThree-persons')}`
            }
            return value;
        }

        const firstHolderInfo = [
            { value: this.searchAbbreviation(holderOneInfo.get('maritalStatus'), maritalStatusOptions) },
            { value: calculateDependentsValue(holderOneInfo.get('dependents')) }];
        const secondHolderInfo = [
            { value: this.searchAbbreviation(holderTwoInfo.get('maritalStatus'), maritalStatusOptions) },
            { value: calculateDependentsValue(holderTwoInfo.get('dependents')) }];

        return (
            <MortgageRequestCardInformation
                title={formatText('mortgageRequestPreApprovalStepThree-maritalStatus')}
                firstHolderInfo={firstHolderInfo}
                secondHolderInfo={secondHolderInfo}
                immMortgageRequest={immMortgageRequest}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                onHandleDependents={formHandlers.handleDependents}
                idModal={MARITAL}
                valid={valid}
                semiComplete={semiComplete}
                errorText={errorText}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                idPreviousModal={DATE_OF_BIRTH}
                idNextModal={HOME_OWNER_SHIP}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                isNavigationButtonsAvailable={validMaritalInformation}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortgageRequestMaritalStatusAndDependents
                    immMortgageRequest={immMortgageRequest}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    responsiveMobileVersion={responsiveMobileVersion}
                />
            </MortgageRequestCardInformation>
        );
    }

    buildHabitualHomeOwership() {
        const {
            immMortgageRequest,
            formHandlers,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;
        const firstHolderInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'owner', 'label'], '');
        const secondHolderInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'owner', 'label'], '');
        const validModal = immMortgageRequest.getIn(['validModals', HOME_OWNER_SHIP], {});
        const valid = validModal.get('valid');
        const semiComplete = this.calculateSemicompleteModal(validModal);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');

        return (
            <MortgageRequestCardInformation
                title={formatText('mortgageRequestPreApprovalStepThree-homeOwnership')}
                firstHolderInfo={[{ value: firstHolderInfo }]}
                secondHolderInfo={[{ value: secondHolderInfo }]}
                immMortgageRequest={immMortgageRequest}
                valid={valid}
                semiComplete={semiComplete}
                errorText={errorText}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                idModal={HOME_OWNER_SHIP}
                idPreviousModal={MARITAL}
                idNextModal={WORK}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortgageRequestHomeOwnershipForm
                    immMortgageRequest={immMortgageRequest}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    responsiveMobileVersion={responsiveMobileVersion}
                />
            </MortgageRequestCardInformation>
        );
    }

    buildWorkSituationAndStudies() {
        const {
            immMortgageRequest,
            formHandlers,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;
        const firstHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);
        const secondHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO]);
        const validModal = immMortgageRequest.getIn(['validModals', WORK]);
        const valid = validModal.get('valid');
        const semiComplete = this.calculateSemicompleteModal(validModal);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');

        const firstHolderInfo = [
            { value: this.searchAbbreviation(firstHolder.getIn(['work', 'value']), laborSituationOptions) },
            { value: this.searchAbbreviation(firstHolder.getIn(['studies', 'value']), studiesLevelOptions) }
        ];
        const secondHolderInfo = [
            { value: this.searchAbbreviation(secondHolder.getIn(['work', 'value']), laborSituationOptions) },
            { value: this.searchAbbreviation(secondHolder.getIn(['studies', 'value']), studiesLevelOptions) }
        ];

        return (
            <MortgageRequestCardInformation
                title={formatText('mortgageRequestPreApprovalStepThree-work')}
                firstHolderInfo={firstHolderInfo}
                secondHolderInfo={secondHolderInfo}
                immMortgageRequest={immMortgageRequest}
                valid={valid}
                semiComplete={semiComplete}
                errorText={errorText}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                idModal={WORK}
                idPreviousModal={HOME_OWNER_SHIP}
                idNextModal={INCOMES_AND_EXPENSES}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortgageRequestWorkForm
                    immMortgageRequest={immMortgageRequest}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    responsiveMobileVersion={responsiveMobileVersion}

                />
            </MortgageRequestCardInformation>
        );
    }

    buildMonthlyIncomeAndExpenses() {
        const {
            immMortgageRequest,
            formHandlers,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;

        const incomesFirstHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'incomes']);
        const expensesFirstHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'expenses']);
        const incomesSecondHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'incomes']);
        const expensesSecondHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'expenses']);

        const income = formatText('mortgageRequestPreApprovalStepThree-income');
        const expenses = formatText('mortgageRequestPreApprovalStepThree-outcome');
        const title = formatText('mortgageRequestPreApprovalStepThree-incomeOutcome');
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');

        const validModal = immMortgageRequest.getIn(['validModals', INCOMES_AND_EXPENSES]);
        const valid = validModal.get('valid');
        const validMonthlyIncomeInformation = incomesFirstHolder !== 0;

        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const firstHolderComplete = validModal.getIn(['fields', HOLDER_OPTION_ONE, 'semiComplete'], false);
        const firstHolderFilled = validModal.getIn(['fields', HOLDER_OPTION_ONE, 'filled'], false);
        let semiComplete = false;

        if (selectedHolder === HOLDER_OPTION_ONE) {
            semiComplete = firstHolderComplete || firstHolderFilled;
        } else {
            semiComplete = (firstHolderComplete || firstHolderFilled) ||
                validModal.getIn(['fields', HOLDER_OPTION_TWO, 'semiComplete'], false) || validModal.getIn(['fields', HOLDER_OPTION_TWO, 'filled'], false);
        }
        const firstHolderInfo = [
            { value: incomesFirstHolder, description: incomesFirstHolder !== '' ? income : '' },
            { value: expensesFirstHolder, description: expensesFirstHolder !== '' ? expenses : '' }
        ];
        const secondHolderInfo = [
            { value: incomesSecondHolder, description: incomesSecondHolder !== '' ? income : '' },
            { value: expensesSecondHolder, description: expensesSecondHolder !== '' ? expenses : '' }
        ];

        return (
            <MortgageRequestCardInformation
                title={title}
                firstHolderInfo={firstHolderInfo}
                secondHolderInfo={secondHolderInfo}
                immMortgageRequest={immMortgageRequest}
                valid={valid}
                semiComplete={semiComplete}
                errorText={errorText}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                idModal={INCOMES_AND_EXPENSES}
                idPreviousModal={WORK}
                idNextModal={OTHER_LOANS_AND_MORTGAGES}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                isNavigationButtonsAvailable={validMonthlyIncomeInformation}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortagageRequestMonthlyIncomeAndExpenses
                    immMortgageRequest={immMortgageRequest}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    responsiveMobileVersion={responsiveMobileVersion}
                />
            </MortgageRequestCardInformation>
        );
    }

    validLoansAndMortgagesInformation(immMortgageRequest) {
        const isSecondHolder = immMortgageRequest.get('selectedHolder') === HOLDER_OPTION_TWO;

        const personalLoansValueOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, PERSONAL_LOANS]);
        const personalLoansValueTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, PERSONAL_LOANS]);

        if (personalLoansValueOne === YES) {
            const monthlyFessLoansOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, MONTHLY_FEES_LOANS]);
            const pendingAmountLoansOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, PENDING_AMOUNT_LOANS]);
            if (monthlyFessLoansOne > pendingAmountLoansOne) {
                return false;
            }
        }
        if (isSecondHolder && personalLoansValueTwo === YES) {
            const monthlyFessLoansTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, MONTHLY_FEES_LOANS]);
            const pendingAmountLoansTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, PENDING_AMOUNT_LOANS]);
            if (monthlyFessLoansTwo > pendingAmountLoansTwo) {
                return false;
            }
        }

        const otherMortgageValueOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, OTHER_MORTGAGE]);
        const otherMortgageValueTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, OTHER_MORTGAGE]);
        const cancelMortgageValueOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, GOING_CANCEL_MORTGAGE]);
        const cancelMortgageValueTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, GOING_CANCEL_MORTGAGE]);

        if (otherMortgageValueOne === YES && cancelMortgageValueOne === NO) {
            const monthlyFessMortgageOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, MONTHLY_FEES_MORTGAGE]);
            const pendingAmountMortagageOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, PENDING_AMOUNT_MORTGAGE]);
            if (monthlyFessMortgageOne > pendingAmountMortagageOne) {
                return false;
            }
        }

        if (isSecondHolder && otherMortgageValueTwo === YES && cancelMortgageValueTwo === NO) {
            const monthlyFessMortgageTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, MONTHLY_FEES_MORTGAGE]);
            const pendingAmountMortagageTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, PENDING_AMOUNT_MORTGAGE]);
            if (monthlyFessMortgageTwo > pendingAmountMortagageTwo) {
                return false;
            }
        }
        return true;
    }

    buildLoansAndMortgages() {
        const {
            immMortgageRequest,
            formHandlers,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;
        const firstHolderMonthlyFees = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'monthlyFeesLoans']);
        const firstHolderAmountLoans = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'pendingAmountLoans']);
        const secondHolderMonthlyFees = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'monthlyFeesLoans']);
        const secondHolderAmountLoans = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'pendingAmountLoans']);
        const firstHolderMonthlyFeesM = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'monthlyFeesMortgage']);
        const firstHolderAmountMortgage = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'pendingAmountMortgage']);
        const secondHolderMonthlyFeesM = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'monthlyFeesMortgage']);
        const secondHolderAmountMortgage = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'pendingAmountMortgage']);
        const validModal = immMortgageRequest.getIn(['validModals', OTHER_LOANS_AND_MORTGAGES], {});
        const valid = validModal.get('valid');
        const errorText = formatText('mortgageRequestPreApprovalStepThree-required');
        const isFirstHolderFeesEmpty = firstHolderMonthlyFees === '' && firstHolderMonthlyFeesM === '';
        const isFirstHolderAmountEmpty = firstHolderAmountLoans === '' && firstHolderAmountMortgage === '';
        const isSecondHolderFeesEmpty = secondHolderMonthlyFees === '' && secondHolderMonthlyFeesM === '';
        const isSecondHolderAmountEmpty = secondHolderAmountLoans === '' && secondHolderAmountMortgage === '';
        const semiComplete = !isFirstHolderFeesEmpty || !isFirstHolderAmountEmpty || !isSecondHolderFeesEmpty || !isSecondHolderAmountEmpty;
        const firstHolderFees = isFirstHolderFeesEmpty ? '' : Number(firstHolderMonthlyFees) + Number(firstHolderMonthlyFeesM);
        const firstHolderAmount = isFirstHolderAmountEmpty ? '' : Number(firstHolderAmountLoans) + Number(firstHolderAmountMortgage);
        const secondHolderFees = isSecondHolderFeesEmpty ? '' : Number(secondHolderMonthlyFees) + Number(secondHolderMonthlyFeesM);
        const secondHolderAmount = isSecondHolderAmountEmpty ? '' : Number(secondHolderAmountLoans) + Number(secondHolderAmountMortgage);

        const validLoansAndMortgagesInformation = this.validLoansAndMortgagesInformation(immMortgageRequest);

        const firstHolderInfo = [
            {
                value: firstHolderFees,
                description: !!`${firstHolderFees}` ? formatText('mortgageRequestPreApprovalStepThree-monthQuota') : ''
            },
            {
                value: firstHolderAmount,
                description: !!`${firstHolderAmount}` ? formatText('mortgageRequestPreApprovalStepThree-import') : ''
            }
        ];
        const secondHolderInfo = [
            {
                value: secondHolderFees,
                description: !!`${secondHolderFees}` ? formatText('mortgageRequestPreApprovalStepThree-monthQuota') : ''
            },
            {
                value: secondHolderAmount,
                description: !!`${secondHolderAmount}` ? formatText('mortgageRequestPreApprovalStepThree-import') : ''
            }
        ];
        return (
            <MortgageRequestCardInformation
                title={formatText('mortgageRequestPreApprovalStepThree-others')}
                firstHolderInfo={firstHolderInfo}
                secondHolderInfo={secondHolderInfo}
                immMortgageRequest={immMortgageRequest}
                errorText={errorText}
                valid={valid}
                semiComplete={semiComplete}
                onHandleValidateObligatoryFields={formHandlers.handleValidateObligatoryFields}
                onHandleChangeModalActive={formHandlers.handleChangeModalActive}
                onHandleActionPreviousNextButton={formHandlers.handleActionPreviousNextButton}
                handlerInfoOtherLoansMortgages={formHandlers.handlerInfoOtherLoansMortgages}
                idPreviousModal={INCOMES_AND_EXPENSES}
                idModal={OTHER_LOANS_AND_MORTGAGES}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                isNavigationButtonsAvailable={validLoansAndMortgagesInformation}
                responsiveMobileVersion={responsiveMobileVersion}
            >
                <MortgageRequestOtherLoans
                    immMortgageRequest={immMortgageRequest}
                    formHandlers={formHandlers}
                    validModal={validModal}
                    responsiveMobileVersion={responsiveMobileVersion}

                />

            </MortgageRequestCardInformation>
        );
    }

    getIsValidStepThree() {
        const { immMortgageRequest } = this.props;
        const validStepThree = immMortgageRequest.getIn(['steps', THIRD_STEP, 'valid']);
        const validated = immMortgageRequest.getIn(['validModals', 'validated']);
        let isValid = true;

        if (!validStepThree && !validated) {
            isValid = true
        } else if (!validStepThree && validated) {
            isValid = false
        } else if (validStepThree && validated) {
            isValid = true
        }

        return isValid;
    }

    render() {
        const isValidStepThree = this.getIsValidStepThree();
        const headerSection = this.buildHeader();
        const holdersSection = this.buildHolders();
        const dateOfBirthCard = this.buildDateOfBirthCard();
        const maritalStatusAndDependents = this.buildMaritalStatusAndDependents();
        const habitualHomeOwership = this.buildHabitualHomeOwership();
        const workSituationAndStudies = this.buildWorkSituationAndStudies();
        const monthlyIncomeAndExpenses = this.buildMonthlyIncomeAndExpenses();
        const loansAndMortgages = this.buildLoansAndMortgages();

        return (
            <section className="mortgage-request-preapproval-step-three">
                {headerSection}
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 mortgage-request-preapproval-step-three__aditional-data-form">
                        <div className="row">
                            {holdersSection}
                            <div className="col-md-12 mortgage-request-preapproval-step-three__cards">
                                <div className="row">
                                    {dateOfBirthCard}
                                    {maritalStatusAndDependents}
                                    {habitualHomeOwership}
                                </div>
                                <div className="row">
                                    {workSituationAndStudies}
                                    {monthlyIncomeAndExpenses}
                                    {loansAndMortgages}
                                </div>
                            </div>
                            <div className="mortgage-request-preapproval-step-three__description-text">
                                <FormattedText value="mortgageRequestPreApprovalStepThree-descriptionText" />
                            </div>
                            {!isValidStepThree && <div className="col-md-12">
                                <div className="mortgage-request-preapproval-step-three__error-message">
                                    <i className="mortgage-request-preapproval-step-three__error-message-icon icon-error" />
                                    <FormattedText value="mortgageRequestPreApprovalStepThree-errorMessage" />
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}

MortgageRequestPreApprovalStepThree.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTaxesInformation: PropTypes.object.isRequired,
    taxesInformationRequest: PropTypes.func.isRequired,
    formHandlers: PropTypes.object.isRequired,
    isClientWithoutAccounts: PropTypes.bool.isRequired,
    discardTemporalChangesInCurrentModal: PropTypes.func,
    clearTemporalChangesInCurrentModal: PropTypes.func,
    immCollectives: PropTypes.object,
    mortgageConditions: PropTypes.object.isRequired,
    requestConditions: PropTypes.func,
}

module.exports = MortgageRequestPreApprovalStepThree;
